import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import { IData, IHttpError } from "_services/api/interface/HttpResponse";
import { getToken } from "_services/auth";
import { alertaErro, alertaSucesso } from "components/Alerta";
import { useState } from "react";
import {
  ILinhaInformeFaturamentoValidada,
} from "../interfaces/ILinhaInformeFaturamento";
import { parseInformeFaturamento } from "../utils/parseExcel";

export function useInformeFaturamento() {
  const [arquivo, setArquivo] = useState<File | null>(null);
  const [numeroCarta, setNumeroCarta] = useState<string>("");
  const [linhas, setLinhas] = useState<ILinhaInformeFaturamentoValidada[]>([]);
  const [loading, setLoading] = useState(false);

  const api = AxiosRequest.makeApi(process.env.REACT_APP_MS_AW);
  const token = getToken();

  async function importar() {
    if (!arquivo) {
      alertaErro("Atenção", "Selecione um arquivo");
      return;
    }

    setLoading(true);
    try {
      const { numeroCarta: carta, linhas: linhasParseadas } = await parseInformeFaturamento(arquivo);

      const { status, data } = await api.post(
        `/emplacamento/informeFaturamento/validar`,
        { linhas: linhasParseadas },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      new HttpResponse(false, status, data);
      setNumeroCarta(carta);
      setLinhas(data);
    } catch (error: IHttpError<IData, any> | any) {
      if (error?.isAxiosError) {
        const response = new HttpError<IData>(true, error);
        alertaErro("Ocorreu um erro", response.data.message);
      } else {
        alertaErro("Atenção", error?.message ?? "Não foi possível processar a planilha");
      }
      setLinhas([]);
    } finally {
      setLoading(false);
    }
  }

  async function salvar() {
    setLoading(true);
    try {
      const { status, data } = await api.post(
        `/emplacamento/informeFaturamento/salvar`,
        { numeroCarta, linhas },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      new HttpResponse(false, status, data);

      const erros: string[] = data?.erros ?? [];
      if (erros.length > 0) {
        alertaErro("Não foi possível atualizar todos os processos!", erros.join("\n"));
        return;
      }

      alertaSucesso("Registros salvos com sucesso!");
      setLinhas([]);
      setNumeroCarta("");
      setArquivo(null);
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      alertaErro("Ocorreu um erro", response.data.message);
    } finally {
      setLoading(false);
    }
  }

  return {
    arquivo,
    setArquivo,
    numeroCarta,
    linhas,
    loading,
    importar,
    salvar,
  };
}
